import { fromJS } from "immutable";

export const getRouteIndex = (state, routeId) => {
  const routes = state.get('routes');

  return routes.findIndex(item => item.get('id') === routeId);
}

export const getRouteData = (state, routeId) => {
  const routes = state.quickAssignment.get('routes');

  return routes
    .find(item => item.get('id') === routeId);
}

export const getDriverAssignments = (state, routeId) => {
  const route = getRouteData(state, routeId);

  if (!route) return [];

  return route.getIn(['route', 'driverAssignments'], fromJS([])).toJS();
};

export const getHelperAssignments = (state, routeId) => {
  const route = getRouteData(state, routeId);

  if (!route) return [];

  return route.getIn(['route', 'helperAssignments'], fromJS([])).toJS();
};

export const getEquipmentAssignments = (state, routeId) => {
  const route = getRouteData(state, routeId);

  if (!route) return [];

  return route.getIn(['route', 'equipmentAssignments'], fromJS([])).toJS();
};

export const getDriverAndHelpersAssignments = (state, routeId) => {
  const routes = state.quickAssignment.get('routes');

  const drivers = routes
    .find(item => item.get('id') === routeId)
    .getIn(['route', 'driverAssignments'], fromJS([]))
    .toJS();

  const helpers = routes
    .find(item => item.get('id') === routeId)
    .getIn(['route', 'helperAssignments'], fromJS([]))
    .toJS();

  return [...drivers, ...helpers];
};

export const getIsDragging = (state, routeId, type) => {
  return state.quickAssignment.getIn(['drags', routeId, type], false);
};
